import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Document, Event, Information, News, OrgUnit, Place, Service } from 'src/app/models/searchresult.model';
import { SharedModuleModule } from '../../shared-module/shared-module.module';
type acceptedType = News | Service | Document | OrgUnit | Place | Information;

@Component({
  selector: 'app-compact-card',
  standalone: true,
  imports: [CommonModule, RouterModule, SharedModuleModule],
  templateUrl: './compact-card.component.html',
  styleUrls: ['./compact-card.component.scss']
})
export class CompactCardComponent<T extends acceptedType> {
  @Input() data!: T;
  isNews(data: acceptedType): data is News {
    return data.type === 'Notizia';
  }

  isService(data: acceptedType): data is Service {
    return data.type === 'Service';
  }

  isDocument(data: acceptedType): data is Document {
    return data.type === 'Document';
  }
  isPlace(data: acceptedType): data is Place {
    return data.type === 'Luogo';
  }
  isOrgUnit(data: acceptedType): data is OrgUnit {
    return data.type === 'Unità';
  }
  isEvent(data: acceptedType): data is Event {
    return data.type === 'Evento';
  }
  isInformation(data: acceptedType): data is Information {
    return data.type === 'Informazione';
  }

}
